import CommitGraph from "../../../../content/blog/do-we-still-need-state-channels/commit-graph.svg";
import * as React from 'react';
export default {
  CommitGraph,
  React
};